export default {"src":"/_next/static/media/planning-center-black@2x.14760612.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};